import FormattedMessage from 'I18n/components/FormattedMessage';
import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { jsx as _jsx } from "react/jsx-runtime";
export const getTextFromSection = section => {
  if (section && ['HTML', 'PLAIN_TEXT', 'COLLABORATE'].includes(section.type)) {
    return section.text;
  }
  consoleIfNotProd.warn('No text found in message response', section);
  return '';
};
export const extractTitleAndContentFromSections = message => {
  const fallbackMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "copilotPlugins.genericMessages.noTextFound"
  });
  if ('sections' in message) {
    const titleText = getTextFromSection(message.sections[0]);
    const contentText = getTextFromSection(message.sections[1]);
    return {
      titleText: titleText || fallbackMessage,
      contentText
    };
  }
  return {
    titleText: fallbackMessage,
    contentText: ''
  };
};
export const copilotV2ExtractTitleAndContentFromSections = message => {
  if ('sections' in message) {
    // COLLABORATE sections are new for v2
    const isV2CollaborateMessage = message.sections.some(section => section.type === 'COLLABORATE');
    if (isV2CollaborateMessage) {
      return {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "copilotPlugins.genericMessages.contentRewrite"
        }),
        contentText: getTextFromSection(message.sections[0])
      };
    }
  }

  // Fallback to the old method for v1
  return extractTitleAndContentFromSections(message);
};
export const extractBrandVoiceInformationFromMessage = message => {
  let brandVoiceChannel;
  let brandVoiceSubChannel;
  let businessUnitId;
  if ('sections' in message) {
    // COLLABORATE sections are new for v2
    const isV2CollaborateMessage = message.sections.length > 0 && message.sections[0].type === 'COLLABORATE';
    if (isV2CollaborateMessage) {
      var _firstSection$refineA;
      const firstSection = message.sections[0];
      const escapedJsonPayload = (_firstSection$refineA = firstSection.refineAction) === null || _firstSection$refineA === void 0 || (_firstSection$refineA = _firstSection$refineA.payload) === null || _firstSection$refineA === void 0 ? void 0 : _firstSection$refineA.payloadJson;
      if (escapedJsonPayload) {
        const payload = JSON.parse(escapedJsonPayload);
        brandVoiceChannel = payload.brandVoiceChannel;
        brandVoiceSubChannel = payload.brandVoiceSubChannel;
        businessUnitId = payload.businessUnitId;
      }
    }
  }
  return {
    brandVoiceChannel,
    brandVoiceSubChannel,
    businessUnitId
  };
};